export default __webpack_public_path__ + "static/media/Pay Per Night - Blue.f2e47f3b.svg";